import React from 'react';
import { AVAILABILITY } from '../config/constants';
import { StyledTitle } from './styled';

const WidgetTitle = ({ title, meta }) => {
  const { availability } = meta;

  return (
    <StyledTitle>
      <span className="title">{title}</span>
      {availability && availability !== AVAILABILITY.GA && <sup>{AVAILABILITY[availability]}</sup>}
    </StyledTitle>
  );
};

export default WidgetTitle;
